/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.8",
    versionName: "0.2.0-nightly.2025.12.8",
    versionChannel: "nightly",
    buildDate: "2025-12-08T00:08:09.153Z",
    commitHash: "3175e411a8d11e0ffc09e746337421db929d0af2",
};
